export default {
	addMinutesToNow(minutes) {
		const d = new Date();
		d.setMinutes(0);
		const d2 = d.setSeconds(0,0) + 1000 * 60 * minutes;
		return new Date(d2);
	},
	addMinutes(origin, minutes) {
		const d = origin.setSeconds(0,0) + 1000 * 60 * minutes;
		return new Date(d);
	}
}
